import { Component, Input } from '@angular/core';
import { Consecuencia } from '../../models/liberacion.models';

@Component({
  selector: 'app-que-pasara',
  templateUrl: './que-pasara.component.html'
})
export class QuePasaraComponent {
  /** null mientras falte elegir la entrega. */
  @Input() lineas: Consecuencia[] | null = null;
}
